import { PostProperties } from "../types";
import image from "../img/lostGemDvs1.jpg";

const post: PostProperties = {
  id: 8,
  title: "DVS1 - System, First Avenue, Minneapolis (09.04.2011)",
  content: `"The club is only open for 4 hours, so this was a start to finish set in the smaller "DJ room" of First Avenue." - DVS1`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/dvs1systemfirstavenueminneapolis",
  category: "Lost Gem",
  translationsBg: {
    content: `„Клубът работи само 4 часа, така че това беше сет от началото до края в по-малката „DJ стая" на First Avenue." – DVS1`,
  },
};

export default post;
